var _path, _path2, _path3, _g, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduationPreparationBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 60,
    viewBox: "0 0 78 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1415 54.2851L67.5529 59.7081L73.8148 59.7081L71.2261 54.2851L70.1415 54.2851ZM70.1415 36.7324L70.1415 54.8274L71.2261 54.8274L71.2261 36.7324L70.1415 36.7324Z",
    fill: "#DDEBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8955 8.71133C48.205 8.63777 48.5311 8.70375 48.7876 8.89183L83.4881 34.3329C84.2331 34.8792 83.9977 36.0473 83.0993 36.2624L42.0947 46.0785C41.7896 46.1515 41.4679 46.0889 41.2126 45.9068L5.70098 20.5904C4.94253 20.0497 5.17354 18.8675 6.07974 18.6521L47.8955 8.71133Z",
    fill: "url(#paint0_linear_4691_18663)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7876 8.89204C48.5311 8.70396 48.2049 8.63798 47.8955 8.71154L6.07969 18.6523C5.33433 18.8295 5.04575 19.6607 5.38884 20.2511C5.52699 20.007 5.76179 19.8124 6.07969 19.7369L47.8955 9.79614C48.2049 9.72258 48.5311 9.78856 48.7876 9.97664L83.488 35.4177C83.6169 35.5122 83.7164 35.6253 83.7883 35.7489C84.0418 35.3013 83.9704 34.6868 83.488 34.3331L48.7876 8.89204Z",
    fill: "url(#paint1_linear_4691_18663)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4691_18663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1353 52.8035L20.321 42.4155L43.6852 38.4356L63.7363 51.203L44.5566 54.2851C41.9852 54.6983 39.3509 54.1724 37.1353 52.8035Z",
    fill: "url(#paint2_linear_4691_18663)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3222 26.0982C24.5209 25.2884 25.1662 24.6641 25.9822 24.4924L42.7885 20.9554C45.7522 20.3317 48.8417 20.9755 51.3095 22.7311L64.6924 32.2518C65.3339 32.7082 65.6778 33.4763 65.5909 34.2588L63.7047 51.2451L46.8903 40.9441C44.6982 39.6011 42.1005 39.0805 39.5602 39.4749L20.3065 42.4647L24.3222 26.0982Z",
    fill: "url(#paint3_linear_4691_18663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4691_18663",
    x: 20.321,
    y: 38.4355,
    width: 43.4153,
    height: 17.0714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0846
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4691_18663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_18663",
    x1: 47.5402,
    y1: 7.95254,
    x2: 47.7059,
    y2: 77.8119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4691_18663",
    x1: 77.7836,
    y1: 12.6865,
    x2: 16.7061,
    y2: -10.7295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353972,
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554518,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEBF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4691_18663",
    x1: 42.0286,
    y1: 38.4355,
    x2: 39.9471,
    y2: 54.0943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4691_18663",
    x1: 18.8825,
    y1: 46.3157,
    x2: 40.6858,
    y2: -2.37489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0294345,
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationPreparationBoardPage);
export default __webpack_public_path__ + "static/media/graduationPreparation-board-page.d6c37fb063869e5207ce0830d5d8e955.svg";
export { ForwardRef as ReactComponent };